import React, { useMemo, useState } from "react";
import classNames from "classnames";
import { SpaceType, VenueSearchResult, WorkspaceSearchResult } from "Services/API/API";
import { FavoriteWidget } from "Components/Favorite/FavoriteWidget";
import { Color } from "Components/Favorite/FavoriteButton";

const WORKSPACES_COUNT = 3;

interface WorkspacesProps {
   venue: VenueSearchResult,
}
const Workspaces: React.FC<WorkspacesProps> = ({ venue }) => {
   const [workspaceIdWithOpenedFavoriteWidget, setWorkspaceIdWithOpenedFavoriteWidget] = useState<Guid | undefined>(undefined);

   const workspacesToDisplay = useMemo(() => {
      let result: WorkspaceSearchResult[] = [];
      const groupedWorkspaces: { [key in SpaceType]?: WorkspaceSearchResult[] } = venue.workspaceSearchResults?.reduce(
         (result, item) => ({
            ...result,
            [item.spaceType]: [
               ...(result[item.spaceType] || []),
               item,
            ],
         }),
         {},
      ) || {};

      Object.keys(groupedWorkspaces).forEach((key) => {
         groupedWorkspaces[key] = groupedWorkspaces[key].sort((a, b) => (a as WorkspaceSearchResult).price > (b as WorkspaceSearchResult).price ? 1 : (a as WorkspaceSearchResult).price < (b as WorkspaceSearchResult).price ? -1 : 0);
      })

      const getWorksaceForType = (spaceType: SpaceType, index: number) => {
         if (result.length == WORKSPACES_COUNT)
            return;
         if ((groupedWorkspaces[spaceType]?.length || 0) > index) {
            result.push(groupedWorkspaces[spaceType]![index]);
         }
      }

      const primarySpaceTypes = [SpaceType.Desk, SpaceType.Office, SpaceType.Meeting];
      const secondarySpaceTypes = [SpaceType.Training, SpaceType.EventSpace];


      for (let i = 0; i < WORKSPACES_COUNT; i++) {
         for (let j = 0; j < primarySpaceTypes.length; j++) {
            getWorksaceForType(primarySpaceTypes[j], i);
         }
         if (result.length == WORKSPACES_COUNT)
            break;
      }

      for (let i = 0; i < WORKSPACES_COUNT; i++) {
         for (let j = 0; j < secondarySpaceTypes.length; j++) {
            getWorksaceForType(secondarySpaceTypes[j], i);
         }
         if (result.length == WORKSPACES_COUNT)
            break;
      }

      if (result.length < WORKSPACES_COUNT)
         result = result.concat(venue.workspaceSearchResults?.filter(w => primarySpaceTypes.indexOf(w.spaceType) < 0 && secondarySpaceTypes.indexOf(w.spaceType) < 0).slice(0, WORKSPACES_COUNT - result.length) || []);

      return result;
   }, [venue]);

   const onFavoriteToggle = (workspaceId: Guid, isOpen: boolean) => {
      if (isOpen) {
         setWorkspaceIdWithOpenedFavoriteWidget(workspaceId)
      } else {
         setWorkspaceIdWithOpenedFavoriteWidget(undefined);
      }
   }

   const [isHovered, setHovered] = useState(false);

   return workspacesToDisplay.length > 0
      ? <div className="venue-card-spaces">
         {workspacesToDisplay.map(workspace => <div key={workspace.id} className={classNames("venue-card-space", { "venue-card-space--hover": workspaceIdWithOpenedFavoriteWidget == workspace.id })} onMouseEnter={() => setHovered(true)}>
            <div className="venue-card-space-name" title={`${workspace.spaceTypeFormatted} for ${workspace.capacity}`}>{workspace.spaceTypeFormatted} for {workspace.capacity}</div>
            <div className="venue-card-space-price">{workspace.priceAmount}{workspace.priceDescription}</div>
            <div className="venue-card-space-favorite">
               {
                  isHovered
                     ? <FavoriteWidget color={Color.gray} venueId={venue.venueId} workspaceId={workspace.id} onToggle={(isOpen) => onFavoriteToggle(workspace.id, isOpen)} />
                     : false
               }
            </div>
         </div>)}
      </div>
      : null
}

export default Workspaces;